import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './assets/css/dashboard.css'
// import GridLoadingSpinner from './components/GridLoadingSpinner/GridLoadingSpinner';
import { routes_all } from './constants/constVariables';
// import HeaderAndFooter from './layouts/HeaderAndFooter/HeaderAndFooter';
import PrivateRoutes from './routing/PrivateRoutes';

import Loader from './components/Loader';
import ApiBasedInactivityCheck from './providers/ApiBasedInactivityCheck';

export default function App() {

    return (
        <>
            <BrowserRouter>
                {/* <HeaderAndFooter> */}
                <Routes>
                    <Route element={<PrivateRoutes />}>
                        {routes_all.map(({ path, Component }, key) => (
                            <Route path={path} key={key} element={Component} exact />
                        ))}
                    </Route>
                    <Route element={<div style={{ height: '100vh', backgroundColor: "#fff", textAlign: 'center', display: "flex", alignItems: "center", justifyContent: "center" }} > <Loader /> </div>} path="/login" />
                </Routes>
                {/* </HeaderAndFooter> */}
            </BrowserRouter>
            <ApiBasedInactivityCheck />
        </>
    );
}


